'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _classCallCheck = _interopDefault(require('@babel/runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('@babel/runtime/helpers/createClass'));
var _inherits = _interopDefault(require('@babel/runtime/helpers/inherits'));
var _possibleConstructorReturn = _interopDefault(require('@babel/runtime/helpers/possibleConstructorReturn'));
var _getPrototypeOf = _interopDefault(require('@babel/runtime/helpers/getPrototypeOf'));
var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var React = require('react');
var React__default = _interopDefault(React);
var A11yDiv = _interopDefault(require('@narvar/nth-a11y-div'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var Header = require('./components/Header.js');
var Body = require('./components/Body.js');
var Label = require('./components/Label.js');
var HorizontalDivider = require('./components/HorizontalDivider.js');

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ButtonCardContainer = styled(A11yDiv).withConfig({
  componentId: "sc-1x7mgsc-0"
})(["height:", ";width:", ";min-height:", ";min-width:", ";border-style:", ";border-color:", ";border-width:", ";border-radius:", ";margin-top:", ";margin-right:", ";margin-bottom:", ";margin-left:", ";padding-top:", ";padding-bottom:", ";padding-right:", ";padding-left:", ";color:", ";background:", ";box-sizing:", ";flex-direction:", ";text-align:", ";&:hover{border-style:", ";border-color:", ";border-width:", ";border-radius:", ";background:", ";}"], function (props) {
  return props.s.height || 'auto';
}, function (props) {
  return props.s.width || 'auto';
}, function (props) {
  return props.s.minHeight || 'auto';
}, function (props) {
  return props.s.minWidth || 'auto';
}, function (props) {
  return props.s.borderStyle || 'solid';
}, function (props) {
  return props.s.borderColor || '#CCC';
}, function (props) {
  return props.s.borderWidth || '0.0625rem';
}, function (props) {
  return props.s.borderRadius || 'none';
}, function (props) {
  return props.s.marginTop || '0.5rem';
}, function (props) {
  return props.s.marginRight || '0.5rem';
}, function (props) {
  return props.s.marginBottom || '0.5rem';
}, function (props) {
  return props.s.marginLeft || '0.5rem';
}, function (props) {
  return props.s.paddingTop || '1.5rem';
}, function (props) {
  return props.s.paddingBottom || '1.5rem';
}, function (props) {
  return props.s.paddingRight || '1rem';
}, function (props) {
  return props.s.paddingLeft || '1rem';
}, function (props) {
  return props.s.color || '#333';
}, function (props) {
  return props.s.background || 'transparent';
}, function (props) {
  return props.s.boxSizing || 'content-box';
}, function (props) {
  return props.layout;
}, function (props) {
  return props.layout === 'row' ? 'left' : 'center';
}, function (props) {
  return props.s.hoverBorderStyle || 'solid';
}, function (props) {
  return props.s.hoverBorderColor || '#0096d4';
}, function (props) {
  return props.s.hoverBorderWidth || '0.0625rem';
}, function (props) {
  return props.s.hoverBorderRadius || 'none';
}, function (props) {
  return props.s.hoverBackground || '#F6F6F6';
});
var ButtonCard = /*#__PURE__*/function (_PureComponent) {
  _inherits(ButtonCard, _PureComponent);
  var _super = _createSuper(ButtonCard);
  function ButtonCard() {
    _classCallCheck(this, ButtonCard);
    return _super.apply(this, arguments);
  }
  _createClass(ButtonCard, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        icon = _this$props.icon,
        layout = _this$props.layout,
        s = _this$props.s,
        onClick = _this$props.onClick;
      return /*#__PURE__*/React__default.createElement(ButtonCardContainer, {
        onClick: onClick,
        s: s,
        style: {
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center'
        },
        layout: layout
      }, /*#__PURE__*/React__default.createElement("div", {
        style: {
          flex: '1 1 auto',
          textAlign: 'center',
          lineHeight: '1rem'
        }
      }, icon), /*#__PURE__*/React__default.createElement("div", {
        style: {
          flex: '2 1 auto',
          margin: layout === 'row' ? '0 0 0 1rem' : '1rem auto 0 auto',
          lineHeight: '1rem'
        }
      }, React__default.Children.map(children, function (child) {
        if (child.type.displayName === 'SmallHeader') {
          return /*#__PURE__*/React__default.cloneElement(child, child.props);
        }
        if (child.type.displayName === 'Divider') {
          return /*#__PURE__*/React__default.cloneElement(child, child.props);
        }
        if (child.type.displayName === 'BigHeader') {
          return /*#__PURE__*/React__default.cloneElement(child, child.props);
        }
        if (child.type.displayName === 'Paragraph') {
          return /*#__PURE__*/React__default.cloneElement(child, child.props);
        }
        return child;
      })));
    }
  }]);
  return ButtonCard;
}(React.PureComponent);
_defineProperty(ButtonCard, "BigHeader", Header.default);
_defineProperty(ButtonCard, "SmallHeader", Label.default);
_defineProperty(ButtonCard, "Paragraph", Body.default);
_defineProperty(ButtonCard, "Divider", HorizontalDivider.default);
ButtonCard.defaultProps = {
  icon: {
    children: null
  },
  layout: 'row',
  children: null,
  onClick: null,
  s: {}
};
ButtonCard.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  layout: PropTypes.oneOf(['row', 'column']),
  icon: PropTypes.node,
  s: PropTypes.shape({
    height: PropTypes.string,
    width: PropTypes.string,
    minWidth: PropTypes.string,
    minHeight: PropTypes.string,
    marginTop: PropTypes.string,
    marginRight: PropTypes.string,
    marginBottom: PropTypes.string,
    marginLeft: PropTypes.string,
    borderStyle: PropTypes.string,
    borderColor: PropTypes.string,
    borderWidth: PropTypes.string,
    borderRadius: PropTypes.string,
    lineHeight: PropTypes.string,
    fontFamily: PropTypes.string,
    fontWeight: PropTypes.string,
    fontSize: PropTypes.string,
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
    hoverBorder: PropTypes.string,
    background: PropTypes.string,
    hoverBorderStyle: PropTypes.string,
    hoverBorderColor: PropTypes.string,
    hoverBackground: PropTypes.string
  })
};

exports.default = ButtonCard;
